// VNYL-1629: fills the mega-menu's product previews on demand. Loaded by sections/header.liquid
// on pages that ship the menu without them; the fetch URL and customer id come from #menuWrap's
// data attributes. The header section is fetched once with ?view=mega-menu
// (templates/index.mega-menu.liquid), which renders the previews, and each .mega-preview-slot
// here takes the markup of the slot at the same position in the response. Runs on the first
// hover or focus of the menu, or once the page is idle where the desktop nav is shown (992px up).
// The slots' markup is kept in sessionStorage for the rest of the session, so later page views
// fill without a request. A failed fetch re-arms the hover/focus trigger.
(function () {
  var wrap = document.getElementById('menuWrap');
  var url = wrap && wrap.getAttribute('data-mega-previews-url');
  if (!url || !window.fetch) return;
  var CACHE_KEY =
    'vinyl_mega_previews:' + url + ':' + (wrap.getAttribute('data-mega-previews-customer') || 'guest');
  var CACHE_TTL_MS = 30 * 60 * 1000;
  var started = false;

  function readCache() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY));
      if (cached && Date.now() - cached.savedAt < CACHE_TTL_MS) return cached.slots;
    } catch (e) {}
    return null;
  }

  function writeCache(slots) {
    try {
      sessionStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ savedAt: Date.now(), slots: slots })
      );
    } catch (e) {}
  }

  // Returns false when the slot counts don't match: the two renders took
  // different branches, so leave the placeholders rather than put a preview
  // under the wrong menu item.
  function fill(slots) {
    var targets = wrap.querySelectorAll('.mega-preview-slot');
    if (!slots.length || slots.length !== targets.length) return false;
    for (var i = 0; i < targets.length; i++) {
      targets[i].innerHTML = slots[i];
    }
    if (window.app && typeof app.addToCart === 'function') app.addToCart();
    if (window.shopifyCustomer && typeof shopifyCustomer.addWishlistIcon === 'function') {
      shopifyCustomer.addWishlistIcon();
    }
    return true;
  }

  function arm() {
    wrap.addEventListener('pointerenter', load);
    wrap.addEventListener('focusin', load);
  }

  function load() {
    if (started) return;
    started = true;
    wrap.removeEventListener('pointerenter', load);
    wrap.removeEventListener('focusin', load);
    var cached = readCache();
    if (cached && fill(cached)) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('mega-menu previews ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var slots = Array.prototype.map.call(
          doc.querySelectorAll('#menuWrap .mega-preview-slot'),
          function (slot) {
            return slot.innerHTML;
          }
        );
        if (fill(slots)) writeCache(slots);
      })
      .catch(function (error) {
        started = false;
        arm();
        console.error('[mega-menu previews]', error);
      });
  }

  arm();
  window.addEventListener('load', function () {
    if (!window.matchMedia('(min-width: 992px)').matches) return;
    if ('requestIdleCallback' in window) {
      requestIdleCallback(load, { timeout: 3000 });
    } else {
      setTimeout(load, 1500);
    }
  });
})();
